import config from '../config';
import selectedEnvironment from '../env';

const BASEAPI = config[selectedEnvironment].API_URL;

const API_URL = `${BASEAPI}`;

export const MouseActivityService = {
  /**
   * POST api/DailyMouseRecords/Increment
   */
  async increment({ userId, userType, caseId, bucketUtc, minutes = 2, token }) {
    const res = await fetch(`${API_URL}/DailyMouseRecords/Increment`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        caseId,
        bucketUtc,
        minutes,
      }),
    });

    if (!res.ok) {
      // optional: throw for caller to handle
      const txt = await res.text();
      throw new Error(`MouseIncrement failed: ${txt}`);
    }
  },

  async filter({AccountantId, UserIds, CaseId, StartUtc, EndUtc, token }) {
    const res = await fetch(`${BASEAPI}/DailyMouseRecords/filter`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ AccountantId,UserIds, CaseId, StartUtc, EndUtc }),
    });
    if (!res.ok) {
      const txt = await res.text();
      throw new Error(`MouseFilter failed: ${txt}`);
    }
    return res.json();
  }
};
